<template>
  <div>
    <el-button icon="el-icon-plus" type="primary" @click="openDialog()">Downline</el-button>
    <el-dialog
      title="Downline"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      :before-close="handleClose"
      top="5vh" 
      
    >
      <el-form
          :model="downlineForm"
          ref="downlineForm"
          label-width="150px"
          size="small"
          :rules="downlineFormRule"
          :label-position="device === 'mobile' ? 'top' : 'right'"
          @submit.prevent.native="searchEnter"
          v-loading="searching"
        >
          <el-form-item label="Customer Type">
            <el-select v-model="searchType" @change="getMemberInfo">
              <el-option label="Person" value="person"></el-option>
              <el-option label="Company" value="company"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Member Code" prop="uniqueID1">
            <el-input v-model="downlineForm.uniqueID1" @input="searchInput"></el-input>
          </el-form-item>

           <el-form-item label="">
            
              <div v-if="searchResult" class="member-info">
                <p><b>Member Info</b></p>
                <p><b>Name</b> : {{ searchResult.name}}</p>
                <p><b>Plus ID</b> : {{ searchResult.uid2}}</p>
                <p><b>Type</b> : {{ searchResult.type}}</p>
                <p><b>Status</b> : {{ searchResult.status}}</p>
              </div>
            
          </el-form-item>



      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submiting" :disabled="searchResult?false:true" @click="submitDownline()"
          >Submit</el-button
        >
        <el-button @click="handleClose">Cancel</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { postDownline } from '@/api/introducer'
import { getMemberInfo } from '@/api/customer'
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    }
  },
  data() {
    return {
      dialogShow: false,
      submiting: false,
      searching:false,
      searchTimeout: null,
      searchResult: null,
      searchType: "person",
      downlineForm: {
        "uniqueID1": "",
        "uniqueID2": ""
      },
      downlineFormRule:{
        uniqueID1: [{required: true, message: "Please enter Menber Code", trigger: "blur"}],
      }
    
    }
  },
  methods:{
    openDialog(){
      this.dialogShow = true;
    },

    postDownline(){
      this.submiting = true
      postDownline(this.$route.params.customer_uid, this.downlineForm).then(({result}) =>{
        this.submiting = false
        if(result){
          this.$notify({
            title: "Success",
            message: `Create introducer downline successfully`,
            type: "success",
            duration: 2000
          });
          this.handleClose()
          this.$emit("submited", true);
        }
      })
    },

    submitDownline(){
      this.$refs.downlineForm.validate((valid) => {
        if (valid) {
          this.postDownline();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    getMemberInfo(){
      this.searching = true
      this.searchResult = null
      this.downlineForm.uniqueID2 = ""
      getMemberInfo({member_code: this.downlineForm.uniqueID1, type: this.searchType }).then(({result, data}) =>{
        this.searching = false
        if(result && data){
          this.searchResult = data
          this.downlineForm.uniqueID2 = data.uid2
        }
      })
    },

    searchEnter(e){
      e.preventDefault()
      this.getMemberInfo()
    },

    searchInput(){
      if(this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(()=>{
        this.getMemberInfo()
      }, 1000)

    },

    handleClose() {
      this.dialogShow = false;
    },
  }
}
</script>

<style lang="scss">
.member-info{
  p{
    line-height: 20px;
  }
}
</style>